import React from 'react';
import MetaAIAboutCircles from '../../components/metaai/MetaAIAboutCircles';

const MetaAIAbout = () => {
  return (
    <div>
      <MetaAIAboutCircles />
    </div>
  )
}

export default MetaAIAbout